import instituteSelector from 'modules/Auth/selectors'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import instRequest from 'utils/instRequest'
import studentRequest from 'utils/studentRequest'
import elasticSearchRequest from 'utils/elasticSearchRequest'
import elasticSearchSyncRequest from 'utils/elasticSearchSyncRequest'

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const setDegreeList = list => {
  return {
    type: 'SET_DEGREE_LIST',
    list,
  }
}

export const setCoursesList = data => {
  return {
    type: 'SET_COURSES_LIST',
    data,
  }
}

export const setListOfSkill = list => {
  return {
    type: 'SET_LIST_OF_SKILL',
    list,
  }
}

export const getCoursesList =
  ({
    page = 0,
    search,
    duration,
    examType,
    degreeFilter,
    skillList,
    statusFilter,
    sort,
    orderBy,
    setLoading,
    domainFilter,
    specializationFilter,
  }) =>
  async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id
    
    let pageKey = `pageLimit=10&pageNo=${page ?? 0}`
    let searchKey = search ? `&search=${search}` : ''
    let durationKey = duration?.length > 0 ? `&duration=${duration}` : ''
    let examTypeKey = examType?.length > 0 ? `&examType=${examType}` : ''
    let degreeFilterKey =
      degreeFilter?.length > 0 ? `&degreeStreamMapId=${degreeFilter}` : ''
    let skillListKey = skillList?.length > 0 ? `&skills=${skillList}` : ''
    let statusFilterKey =
      statusFilter?.length > 0 ? `&status=${statusFilter}` : ''
    let sortKey = sort ? `&sort=${sort}` : ''
    let orderKey = orderBy ? `&order=${orderBy}` : ''
    let domainId = domainFilter?.length > 0 ? `&domainId=${domainFilter}` : ``
    let specializationKey = specializationFilter?.length > 0 ? `&specializationIds=${specializationFilter}` : ''
    
    setLoading(true)
    try {
      const res = await instRequest.get(
        `/institutes/instituteCampus/${instituteCampusId}/courses?${pageKey}${sortKey}${orderKey}${searchKey}${durationKey}${examTypeKey}${degreeFilterKey}${skillListKey}${statusFilterKey}${domainId}${specializationKey}`
      )
      dispatch(setCoursesList(res?.data?.data))
      setLoading(false)
      return true
    } catch (error) {
      setLoading(false)
    }
  }

export const AddCourses = payload => async (dispatch, getState) => {
  const state = getState()
  const instituteCampusId = instituteSelector.getInstituteDetails(state).id
  try {
    const result = await instRequest.post(
      `/institutes/instituteCampus/${instituteCampusId}/course`,
      payload
    )
    function formatDate(date) {
      let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
    
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
    
      return [year, month, day].join('-');
    }

 
      let payloadData = {
        query_date: formatDate(new Date())  // This will format today's date as "yyyy-mm-dd"
      };

    await elasticSearchSyncRequest.post(`/sync/institute_campus_cources`,payloadData)
    SuccessMessage('Course Added Successfully')

    return result
  } catch (error) {
    if (
      error?.response?.data?.message ===
      'This degreeStreamMapId isAlready Exists'
    ) {
      ErrorMessage('This Degree And Department is Already Exist')
    } else {
      ErrorMessage(error?.response?.data?.message)
    }
    return error?.response
  }
}

export const getSkillList =
  (setLoading, searchValue, pageNum = 0, pageLimit = 50) =>
  async (dispatch, getState) => {
    let search = searchValue ? `&search=${searchValue}` : ''
    try {
      const result = await studentRequest.get(
        `students/skills/list?pageLimit=${50}&pageNo=${0}${search}`
      )
      dispatch(setListOfSkill(result?.data?.data || {}))
      return result
    } catch (error) {}
  }

export const getSkill = searchValue => async (dispatch, getState) => {
  let SearchKey = searchValue ? `&search=${searchValue}` : ''

  try {
    const result = await studentRequest.get(
      `students/skills/list?pageNo=1&pageLimit=50${SearchKey}`
    )
    dispatch(setListOfSkill(result?.data?.data))
    return result
  } catch (error) {
    ErrorMessage(error?.message)
    dispatch(setListOfSkill({}))
  }
}

export const getDegreeData =
  (searchValue, degreeType, domainId, mappedSpecialisation) => async (dispatch, getState) => {
    try {

      let search = searchValue ? `&search=${searchValue}` : '';
      let degree = degreeType ? `&degreeType=${encodeURIComponent(degreeType)}` : '';
      let domain = domainId ? `&domainId=${domainId}` : '';
      let mappedSpecialisationParam = mappedSpecialisation ? `&mappedSpecialisation=${mappedSpecialisation}` : '';

      const apiUrl = `/institutes/search/degreeStreams?pageLimit=500&pageNo=0${search}${degree}${domain}${mappedSpecialisationParam}`;
      console.log('=== getDegreeData API call ===');
      console.log('API URL:', apiUrl);
      console.log('Parameters:', { searchValue, degreeType, domainId, mappedSpecialisation });

      const data = await instRequest.get(apiUrl);
      
      console.log('API response:', data?.data?.data);
      return data?.data?.data;
    } catch (error) {
      console.error('Error in getDegreeData:', error);
      console.error('Error response:', error?.response?.data);
      return { result: [], error: error?.response?.data };
    }
  };


export const DeleteCourses = (id,setLoading) => async (dispatch, getState) => {
  const state = getState()
  const instituteCampusId = instituteSelector.getInstituteDetails(state).id
  try {
    setLoading(true)
    const result = await instRequest.delete(
      `/institutes/instituteCampus/${instituteCampusId}/course/${id}`
    )
  
      
    let payloadDelete = {
      course_id:  id  
    };
    await elasticSearchSyncRequest.post(`/sync/del_index_institute_campus_cources`,payloadDelete)
    await delay(3000);

    setLoading(false)
    SuccessMessage('Course Deleted Successfully')

    return result
  } catch (error) {
    setLoading(false)
    ErrorMessage(error?.response?.data?.message)
    return error?.response
  }
}

export const EditCourses = (id, payload) => async (dispatch, getState) => {
  const state = getState()
  const instituteCampusId = instituteSelector.getInstituteDetails(state).id
  try {
    const result = await instRequest.put(
      `/institutes/instituteCampus/${instituteCampusId}/course/${id}`,
      payload
    )
    const mappedNames = result?.data?.data?.courseData?.mappedNames
    function formatDate(date) {
      let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
    
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
    
      return [year, month, day].join('-');
    }
    let payloadDelete = {
      course_id:  id  
    };
    await elasticSearchSyncRequest.post(`/sync/del_index_institute_campus_cources`,payloadDelete)
    await delay(3000);
      let payloadData = {
        query_date: formatDate(new Date())  // This will format today's date as "yyyy-mm-dd"
      };

    await elasticSearchSyncRequest.post(`/sync/institute_campus_cources`,payloadData)

    if(mappedNames?.length){
      ErrorMessage(`${mappedNames?.join(',')} are assigned to a candidate`)
    }else{
      SuccessMessage('Course Edited Successfully')
    }
    return result
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
    return error?.response
  }
}

export const ActiveIsCourses = (id, payload) => async (dispatch, getState) => {
  try {
    const result = await instRequest.patch(
      `/institutes/course/${id}/status`,
      payload
    )
    function formatDate(date) {
      let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
    
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
    
      return [year, month, day].join('-');
    }

 
      let payloadData = {
        query_date: formatDate(new Date())  // This will format today's date as "yyyy-mm-dd"
      };

    await elasticSearchSyncRequest.post(`/sync/institute_campus_cources`,payloadData)
    SuccessMessage('Course Status Updated Successfully')

    return result
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
    return error?.response
  }
}

export const DeleteSpecialization =
  (courseId, id) => async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id
    try {
      const result = await instRequest.delete(
        `/institutes/instituteCampus/${instituteCampusId}/course/${courseId}`
      )
      function formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
      
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
      
        return [year, month, day].join('-');
      }
  
   
        let payloadData = {
          query_date: formatDate(new Date())  // This will format today's date as "yyyy-mm-dd"
        };
  
      await elasticSearchSyncRequest.post(`/sync/institute_campus_cources`,payloadData)
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error?.response
    }
  }

export const AddMultiCourses = payload => async (dispatch, getState) => {
  const state = getState()
  const instituteCampusId = instituteSelector.getInstituteDetails(state).id
  try {
    const result = await instRequest.post(
      `/institutes/instituteCampus/${instituteCampusId}/courses`,
      payload
    )
    if (result?.data?.error?.alreadyEXistRecords?.length > 0) {
      ErrorMessage('Course Already Exist')
    } else {
      SuccessMessage('Course Added Successfully')
    }
    function formatDate(date) {
      let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
    
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
    
      return [year, month, day].join('-');
    }

 
      let payloadData = {
        query_date: formatDate(new Date())  // This will format today's date as "yyyy-mm-dd"
      };

    // Indexing must not hold the create flow open. The course is already saved
    // once the institute API responds, so allow the drawer to close promptly.
    elasticSearchSyncRequest
      .post(`/sync/institute_campus_cources`, payloadData)
      .catch(() => undefined)

    return result
  } catch (error) {
    if (
      error?.response?.data?.message ===
      'This degreeStreamMapId isAlready Exists'
    ) {
      ErrorMessage('This Degree And Department is Already Exist')
    } else {
      ErrorMessage(error?.response?.data?.message)
    }
    return null
  }
}

export const dropDownValues = async ({ url, type = 'get' }) => {
  const options = {
    method: type,
    url: `/institutes/${url}`,
  }
  const response = await instRequest(options)

  return response?.data
}
